
import React from "react";

export const AccessDenied = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Access Denied</h1>
        <p className="text-muted-foreground">
          Only App Owners can access this page.
        </p>
      </div>
    </div>
  );
};
